import React from "react";
import ProductDetails from "../components/Product-Detail/Productdetail";


const ProductDetailsrange = () => {
  return (
    <>
    <ProductDetails/>     
    </>

  )
};

export default ProductDetailsrange;